import config from '@/config';
import { YgdRoutes } from '@/enums';
//TODO: fix temporary solution
const communityUrl = 'https://dsyjetutcrwk5.cloudfront.net/documents/YouGov_Chat_Community_Guidelines_-_Global.pdf';

const redirectMap = {
    privacy: '/account/privacy-policy',
    'terms-and-conditions': '/account/terms-and-conditions',
    'community-guidelines': communityUrl,
};

const setYougovUrl = (locale: string, redirectId: string) => {
    const country = locale?.split('-').reverse().join('-') || 'gb-en';
    return 'https://account.yougov.com/' + country + redirectId;
};

export default function ({ route, redirect, from, store }) {
    const pathParts = route.path.split('/');
    const routeName = pathParts[pathParts.length - 1];

    if (Object.keys(redirectMap).includes(routeName)) {
        const redirectId = redirectMap[routeName];
        if (redirectId) {
            const hasFullPath = redirectId.startsWith('http');
            const route = hasFullPath ? redirectId : setYougovUrl(store.$i18n?.locale, redirectId);
            if (from) {
                window.open(route, '_blank');
            } else {
                return redirect(302, route);
            }
        }

        return redirect(from?.path || '/');
    }
    if (!config.featureToggle.useDailyChat && route.name.startsWith('daily-chat')) {
        return redirect('/');
    }

    if (!config.featureToggle.dailyChatProductPageEnabled && route.name === 'daily') {
        return redirect('/');
    }

    if (!config.featureToggle.useDailyChat && route.name === 'user-preferences') {
        return redirect('/');
    }

    if (route.path === '/channels' || route.path === '/channels/') {
        return redirect('/');
    }

    const ygdRouteNames = [YgdRoutes.Tasks, YgdRoutes.History, YgdRoutes.Profile];

    if (ygdRouteNames.some((path) => route.path.startsWith(path))) {
        return redirect(YgdRoutes.Balance);
    }
}
